module.exports = __webpack_public_path__ + "static/img/weixin.d9178b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weixin.png
// module id = q0uv
// module chunks = 27